import { type FC, useCallback } from 'react'

import CloseIcon from '@/assets/icons/icon-close.svg'
import { DIALOG_TYPE } from '@/dialogs/constants.ts'
import { openDialog } from '@/models/dialogs.ts'
import FullScreenIcon from '@/modules/chatting/icons/full-screen.svg'
import { classNames } from '@/utils/helpers'

import { IconButton } from '../components/icon-button'

interface Props {
  giphyId: string
  className?: string
  onRemove?: () => void
  allowOpenInDialog?: boolean
}

const blackBlurredBackground =
  'bg-black bg-opacity-40 backdrop-blur-[10px] text-white'

export const ChatGifMedia: FC<Props> = ({
  giphyId,
  className,
  onRemove,
  allowOpenInDialog,
}) => {
  const handleDialogOpen = useCallback(
    () =>
      openDialog({
        type: DIALOG_TYPE.LOAD_GIF,
        giphyId,
      }),
    [giphyId],
  )

  return (
    <div
      className={classNames('relative overflow-hidden rounded-lg', className)}
    >
      <img
        src={`https://media.giphy.com/media/${giphyId}/giphy.gif`}
        alt="gif"
        className="h-full w-full object-cover"
      />
      {onRemove ? (
        <IconButton
          rounded
          icon={CloseIcon}
          onClick={onRemove}
          className={classNames(
            blackBlurredBackground,
            'absolute right-1.5 top-1.5 h-6 w-6',
          )}
        />
      ) : (
        <div
          className={classNames(
            blackBlurredBackground,
            'absolute right-1.5 top-1.5 flex items-center justify-center rounded-md px-3 py-1 text-sm leading-[22px]',
          )}
        >
          GIF
        </div>
      )}
      {allowOpenInDialog && (
        <IconButton
          rounded
          icon={FullScreenIcon}
          onClick={handleDialogOpen}
          className={classNames(
            blackBlurredBackground,
            'absolute bottom-1.5 right-1.5 h-9 w-9',
          )}
        />
      )}
    </div>
  )
}
